(function (ns, fetch) {

    const loadScript = function (url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function () {
                callback();
            };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    };

    var loadStyle = function (url) {
        var style = document.createElement("link")
        style.type = "text/css"
        style.media = "all"
        style.rel = "stylesheet"
        style.href = url
        document.getElementsByTagName("head")[0].appendChild(style)
    };
  
  	let ssppCurrency = {
      money_format : "${amount}",
      formatMoney : function(cents, format) {
        if (typeof cents == 'string') { cents = cents.replace('.',''); }
        var value = '';
        var placeholderRegex = /\{\s*(\w+)\s*\}/;

        var formatString = (format || this.money_format);

        function defaultOption(opt, def) {
           return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal   = defaultOption(decimal, '.');

          if (isNaN(number) || number == null) { return 0; }

          number = (number/100.0).toFixed(precision);

          var parts   = number.split('.'),
              dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              cents   = parts[1] ? (decimal + parts[1]) : '';

          return dollars + cents;
        }
		
        //console.log(formatString)
        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      }
    }


    let ssppApp = function ($) {
        var isCartUpdated = false;
      	
        let sspp = {
            settings: {
              listItemWrapper: 'item',
              hideToggle: false,
              toggleWrapper:'smartshyp-wrapper'
            },
            init: async function () {
              	
                await this.getPackage()

				this.getCart(ssppCart.insertPackageIntoCart)

                let formGlobal = $('form[action="/cart"]') || $('form[action="/checkout"]')

                if (formGlobal.html() != undefined) {
                    this.getCart(ssppCart.updatePackageCart)
                }

                formGlobal.on('submit', function () {
                    localStorage.removeItem('__isSSPPLoad')
                })

                $('body').delegate("a:contains('Package Protection'), a[href*='ppcom-package-protection']", 'click', function (e) {
                    e.preventDefault(); e.stopPropagation();
                })

            },
            _getCookie: (value) =>{
                let name = value + "="
                let ca = document.cookie.split(';')
                for(let i = 0; i < ca.length; i++) {
                  let c = ca[i]
                  while (c.charAt(0) == ' ') {
                    c = c.substring(1)
                  }
                  if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length)
                  }
                }
                return ""
            },
 			_replaceContent: (html) => {
                var tempElement = document.createElement('div');
                tempElement.innerHTML = html;

                var cartNodeParent = document.querySelector('.Cart').parentNode;
                cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), document.querySelector('.Cart'));
                document.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
                
            },
            getPackage: async function () {
                let response = await fetch('/products/ppcom-package-protection.js');
                let data = await response.json()
                localStorage.setItem('sspp', JSON.stringify(data))
            },
            getCart: function (callback) {
                $.getJSON('/cart.js', callback);
            },
            AddPackageToCart: function (variant) {
              
                $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        items: [
                            {
                                quantity: 1,
                                id: variant.id
                            }
                        ]
                    },
                    success: function (data) {
                        localStorage.removeItem('__isSSPPLoad')
                        localStorage.setItem('_ssppvId', variant.id)
                        sspp.getCart(ssppCart.updatePackageCart)

                        $.getJSON('/cart.js', function(cart){
                            $('.subtotal').text(ssppCurrency.formatMoney(cart.items_subtotal_price, "${amount}"))
                            $('.pp-price').html(window.ssppprice)
                            if (sspp.shouldUpdatePangaea()) {
                              sspp.convertPackagePrice(variant.id)
                              sspp.updatePangaeaCartArtifacts(variant.id, true)
                            }
                        });
                        
                    }
                })
            },
            _checkOldPP: function(cart){
              	var id = sspp.settings.oldPPProductId
              	var current_item = cart.items.find(i => i.product_id === id)
                if(current_item){
                  //console.log(current_item)
                  $.ajax({
                      url: '/cart/change.js',
                      type: 'POST',
                      dataType: 'json',
                      data: {
                          quantity: 0,
                          id: current_item.variant_id
                      },
                      success: function (response) {
                          localStorage.setItem('_ssppOption', true)
                          sspp.getCart(ssppCart.updatePackageCart)  
                      }
                  })
                }
            },
            UpdatePackageToCart: function (id) {
                $.ajax({
                    url: '/cart/change.js',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        quantity: 1,
                        id: id
                    },
                    success: function (response) {
                        localStorage.removeItem('__isSSPPLoad')
                    }
                })
            },
            removePackageFromCart: function (id) {
                let isThis = this
                $.ajax({
                    url: '/cart/change.js',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        quantity: 0,
                        id: id
                    },
                    success: function (data) {
                      	
                        localStorage.removeItem('__isSSPPLoad')
                        sspp.getCart(ssppCart.updatePackageCart)
                        
                        /** Custom Script */

                        $.getJSON('/cart.js', function(cart){
                            $('.subtotal').text(ssppCurrency.formatMoney(cart.items_subtotal_price, "${amount}"))
                            $('.pp-price').html(window.ssppprice)
                            if (sspp.shouldUpdatePangaea()) {
                              sspp.convertPackagePrice(id)
                              sspp.updatePangaeaCartArtifacts(id, false)
                            }
                        });
                    }
                })
            },
            ajaxLoadEndListener: function () {
                var package = JSON.parse(localStorage.getItem('sspp'))
                if (this._url == '/cart/add.js') {
                  //sspp.getCart(ssppCart.updatePackageCart)
                }
                this.removeEventListener('loadend', sspp.ajaxLoadEndListener)
            },
            shouldUpdatePangaea: function() {
              return window.PMALL && window.PMALL.getSelectedCountry() !== "US"
            },
            convertPackagePrice: function (variantId) {
              var updatedPPPrice = $('.pp-price').clone().attr("data-product-variant-id", variantId)
              updatedPPPrice.attr('data-role', 'price')
              updatedPPPrice.attr('data-variant', 'without-currency')
              var ppParent = $('.pp-price').parent()
              $('.pp-price').remove()
              ppParent.append(updatedPPPrice)
            },
            updatePangaeaCartArtifacts: function (variantId, shouldEnable) {
              if ($("#sspp_cart_item").length) {
                $('#sspp_cart_item').remove()
              }
              $('.offcanvas-body .product-list').append(
                $("<li>", {
                  "id": "sspp_cart_item",
                  "class":"product-list-item visually-hidden",
                  "data-cart-role":"lineitem",
                  "data-cart-item-quantity": shouldEnable ? 1 : 0
                }).append(
                  $('<span data-role="price" data-cart-role="individual-price" data-variant="without-currency" data-product-variant-id="' + variantId + '">')
                )
              )
            }
        }

        let ssppCart = {
            insertPackageIntoCart: function (cart) {
			
                localStorage.setItem('_ssppToken', cart.token)
                var package = JSON.parse(localStorage.getItem('sspp'))

                var cartPrice = ssppCart.getCartTotal(cart, true)
                var ssppVariant = ssppCart.getMatchedVariant(cartPrice)
                window.ssppprice = ssppVariant.public_title
                var ssppSettings = sspp.settings
                var sspptheme = ssppSettings.cartTheme

                if (localStorage.getItem('sspp') !== null) {

                    if (localStorage.getItem('_ssppOption') === 'true') {
                        var current_item = cart.items.find(i => i.product_id === package.id)
                        if (current_item == undefined) {
                            sspp.getCart(ssppCart.updatePackageCart)
                            localStorage.removeItem('__isSSPPLoad')
                        } else {
                          	//console.log(current_item)
                            window.ssppprice = current_item.variant_title
                        }
                    }

                    /*Hide Page Item*/
                    var cartItemClass = ssppSettings.listItemWrapper
                    cartItemClassArray = cartItemClass.split(",")

                    if (cartItemClassArray.length > 1) {
                        var cartItemClass = []
                        $.each(cartItemClassArray, (a, b) => {
                            cartItemClass.push('.' + b.trim())
                        })
                        cartItemClass = cartItemClass.join(",")
                    } else {
                        cartItemClass = '.' + cartItemClass
                    }


                    /*Hide Page Item*/

                    var formInterval = setInterval(() => {
                                                   
                        if($('.pp-price').html() == ""){                           
                        	sspp.getCart(ssppCart.updateSSPPPrice)
                    	}

                        $("a:contains('Package Protection')").parents('.product-list-item').hide()                           	
                        
                    	let form = $('form[action="/cart"]') || $('form[action="/checkout"]')
                        if (ssppSettings.hideToggle == true) {
                            ssppCart.hideCart(cartItemClass)
                        } else {
                            $("a:contains('Package Protection')").parents(cartItemClass).hide();
                            //$("a:contains('Package Protection')").parents(cartItemClass).find("a:contains('Remove')").hide()
                        }

                        if ($('body').hasClass('template-cart') && form.length > 1) {
                            $.each(form, function () {
                                if ($(this).html() != undefined) {
                                    if ($(this).find('.pp-container').html() == undefined) {
                                        current_item = cart.items.find(i => i.product_id === package.id)

                                        if (cart.items) {
                                            /*Hide AJAX Item*/
                                            if (ssppSettings.hideToggle == true) {
                                                ssppCart.hideCart(cartItemClass)
                                            }

                                            /*Hide AJAX Item*/

                                            sspp.getCart(ssppCart.updateSSPPPrice)

                                            var sspp_template = ssppCart.getPackageTemplate(ssppVariant);
                                            var ssppForm_width = $(this).width()

                                            /*Dynamic Object Handler*/
                                            
                                            var packageProtectionWrapperClass = ssppSettings.toggleWrapper
                                            var ppheight = 0;
                                            packageProtectionWrapperArray = packageProtectionWrapperClass.split(",")
                                            if (packageProtectionWrapperArray.length > 1) {
                                                var ppClass = []
                                                $.each(packageProtectionWrapperArray, (a, b) => {
                                                    ppClass.push('.' + b.trim())
                                                    ppheight = $('.' + b.trim()).css("height")
                                                    if ($(this).find('.' + b.trim()).html() != undefined) {
                                                        $(this).find('.' + b.trim()).prepend(sspp_template)
                                                        //$( sspp_template ).insertBefore( $(this).find('.' + b.trim()) );
                                                      	$(this).find('.' + b.trim()).prepend(sspp_template)
                                                    }
                                                })
                                                //packageProtectionWrapperClass = ppClass.join(",")
                                            } else {
                                                packageProtectionWrapperClass = '.' + packageProtectionWrapperClass
                                                //$( sspp_template ).insertBefore( packageProtectionWrapperClass );
                                                $(packageProtectionWrapperClass).prepend(sspp_template)
                                            }

                                            //$('.package-protection-container').addClass(sspptheme)
											
                                            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                                            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                                              return new bootstrap.Tooltip(tooltipTriggerEl)
                                            })

                                            //$('.package-protection-container').addClass(sspptheme)

                                            $('body').on("click", "#offcanvas-cart-footer-upsell-checkbox", function (e) {
                                              if($(this).is(':checked')){
                                                  localStorage.setItem('_ssppOption', true);
                                                  sspp.getCart(ssppCart.updatePackageCart);
                                              } else {
                                                  $.getJSON('/cart.js', function(cart){
                                                    var current_variant = cart.items.find(i => i.product_id === package.id)
                                                    sspp.removePackageFromCart(current_variant.variant_id)
                                                    localStorage.setItem('_ssppOption', false);
                                                  });
                                              }
                                            })
                                            
                                            if (ssppForm_width < 350) {
                                                ppheight = parseInt(ppheight, 10)

                                                $(this).find('.package-protection-container, .package-protection-right').addClass('small')
                                                $(this).find('.package-protection-container').css({ height: '85px' })
                                            }
                                            if ($("#packageProtectionInfoPopup").html() == undefined) {
                                                var sspp_opt = ssppCart.buildPopupWindow();
                                                $('body').append(sspp_opt)
                                            }
                                            ssppCart.setSSPPHeight()
                                        }
                                    }
                                }
                            })
                        } else {
                            if (form.html() != undefined) {
                                if ($('.pp-container').html() == undefined) {
                                    current_item = cart.items.find(i => i.product_id === package.id)
                                    
                                    if (cart.items) {
                                      
                                        sspp.getCart(ssppCart.updateSSPPPrice)

                                        var sspp_template = ssppCart.getPackageTemplate(ssppVariant);
                                        var ssppForm_width = form.width()

                                        /*Dynamic Object Handler*/
                                        var packageProtectionWrapperClass = ssppSettings.toggleWrapper
                                        var ppheight = 0;
                                        packageProtectionWrapperArray = packageProtectionWrapperClass.split(",")
                                        if (packageProtectionWrapperArray.length > 1) {
                                            var ppClass = []
                                            $.each(packageProtectionWrapperArray, (a, b) => {
                                                ppClass.push('.' + b.trim())
                                                ppheight = $('.' + b.trim()).css("height")
                                            })
                                            packageProtectionWrapperClass = ppClass.join(",")
                                        } else {
                                            packageProtectionWrapperClass = '.' + packageProtectionWrapperClass
                                        }

                                        $(packageProtectionWrapperClass).prepend(sspp_template)

                                        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                                        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                                          return new bootstrap.Tooltip(tooltipTriggerEl)
                                        })
										
                                        $('body').on("click", "#offcanvas-cart-footer-upsell-checkbox", function (e) {
                                          if($(this).is(':checked')){
                                              localStorage.setItem('_ssppOption', true);
                                              sspp.getCart(ssppCart.updatePackageCart);
                                          } else {
                                              $.getJSON('/cart.js', function(cart){
												var current_variant = cart.items.find(i => i.product_id === package.id)
                                                sspp.removePackageFromCart(current_variant.variant_id)
                                                localStorage.setItem('_ssppOption', false);
                                              });
                                          }
                                        })
                                        
                                        if (ssppForm_width < 350) {
                                            ppheight = parseInt(ppheight, 10)
                                            $('.package-protection-container').css({ height: '85px' })
                                            form.find('.package-protection-right').addClass('small')
                                        }
                                        if ($("#packageProtectionInfoPopup").html() == undefined) {
                                            var sspp_opt = ssppCart.buildPopupWindow();
                                            $('body').append(sspp_opt)
                                        }
                                        ssppCart.setSSPPHeight()
                                    }
                                }
                            }
                          
                        }
                    }, 1000)
                }
            },
            updatePackageCart: function (cart) {
                var package = JSON.parse(localStorage.getItem('sspp'))
				//console.log(cart);
                if (localStorage.getItem('_ssppOption') === null) {
                    localStorage.setItem('_ssppOption', true)
                }

                if (localStorage.getItem('_ssppToken') === null) {
                    localStorage.setItem('_ssppToken', cart.token)
                }

                var _cartToken = localStorage.getItem('_ssppToken')
                var _ssppOption = localStorage.getItem('_ssppOption')

                if (_ssppOption === 'false' && _cartToken != cart.token) {
                    localStorage.setItem('_ssppOption', true)
                    localStorage.setItem('_ssppToken', cart.token)
                    _ssppOption = localStorage.getItem('_ssppOption')
                }
				
                if (package !== null && _ssppOption === 'true') {
                    var cartPrice = ssppCart.getCartTotal(cart, true)

                    var current_item = cart.items.find(i => i.product_id === package.id)
                    var priceTier = 1;
                    if (cartPrice > 10000) {
                        priceTier = 1 + (Math.ceil((cartPrice - 10000) / 1500))
                    }

                    var variantSKU = "PPTIER" + priceTier.toString();
                  	
                    var matchedVariant = package.variants.find(v => v.sku.toLowerCase() === variantSKU.toLowerCase())
                  
                    if( matchedVariant == undefined ){
                      matchedVariant = package.variants[package.variants.length-1]
                    }

                    if(current_item == undefined && priceTier <= 100){
                      sspp.AddPackageToCart(matchedVariant)
                      //localStorage.removeItem('__isSSPPLoad')
                    } else if(current_item == undefined && priceTier > 100){
                      	sspp.AddPackageToCart(matchedVariant)
                    } else { 
                      if(current_item.variant_id != matchedVariant.id || current_item.quantity > 1){  
                        sspp.removePackageFromCart(current_item.variant_id)
                      }
                    }
                }

            },
            updateSSPPPrice: function (cart) {
                var package = JSON.parse(localStorage.getItem('sspp'))
                var cartPrice = ssppCart.getCartTotal(cart, true)
                var ssppVariant = ssppCart.getMatchedVariant(cartPrice)
                var sspp_price = ssppVariant.price
                var current_item = cart.items.find(i => i.product_id === package.id)
                if (current_item != undefined && current_item.quantity < 2) {
                    sspp_price = current_item.line_price
                }
              	$('.pp-price').text(ssppVariant.public_title)
                if (sspp.shouldUpdatePangaea()) {
                  sspp.convertPackagePrice(ssppVariant.id)
                  if (localStorage.getItem('_ssppOption') === 'true') {
                    sspp.updatePangaeaCartArtifacts(ssppVariant.id, true)
                  }
                }
                window.ssppprice = ssppVariant.public_title
            },
            hideCart: function (cartItemClass) {
                var itemRowDom = $("." + cartItemClass).find("a:contains('Package Protection')")
                itemRowDom.parents("." + cartItemClass).hide()
            },
            getMatchedVariant: function (cartPrice) {
                var package = JSON.parse(localStorage.getItem('sspp'))
                var priceTier = 1;
              	
                if (cartPrice > 10000) {
                  priceTier = 1 + (Math.ceil((cartPrice - 10000) / 1500))
                }
                var variantSKU = "PPTIER" + priceTier.toString();
                var matchedVariant = package.variants.find(v => v.sku.toLowerCase() === variantSKU.toLowerCase())

                if (matchedVariant == undefined) {
                  matchedVariant = package.variants[package.variants.length - 1]
                }

                return matchedVariant

            },
            getPackageTemplate: function (variant) {
              	//console.log(variant)
                if (localStorage.getItem('sspp') !== null) {
                    var package = JSON.parse(localStorage.getItem('sspp'))
                    var enabled = (localStorage.getItem('_ssppOption') !== null) ? localStorage.getItem('_ssppOption') : true
                    
                    var packageImgURL = package.featured_image
                    var packageTitle = package.title
                    var description = package.description
                    var ppbuild = $('<div>', {
                      class: "form-check form-switch mb-3 pp-container"
                    }).append(
                      $("<input>",{
                        "id":"offcanvas-cart-footer-upsell-checkbox",
                        "class":"form-check-input",
                        "type":"checkbox",
                        "role":"switch",
                        "data-variant-id": variant.id,
                        "checked":(enabled === 'true' || enabled === true) ? true : false
                		
                      }),
                      $("<label>", { 
                        	"class":"form-check-label small d-flex align-items-center justify-content-between",
                        	"for":"offcanvas-cart-footer-upsell-checkbox",
                        	"data-bs-toggle":"tooltip",
                        	"data-bs-placement":"top",
                        	"data-bs-html":"true",
                        	"title":description
                      }).append(
                      		$('<span>').html(packageTitle+" [?]"),
                            $('<span class="pp-price">').html(variant.public_title)
                      )
                    )

                    // For initialization if pre-selected
                    if (sspp.shouldUpdatePangaea()) {
                      if (!$("#sspp_cart_item").length && localStorage.getItem('_ssppOption') === 'true') {
                        sspp.updatePangaeaCartArtifacts(variant.id, true)
                      }
                    }
                    
                    return ppbuild;
                }
            },
            setSSPPHeight: function () {
                var ssppDOM = $('.package-protection-container')
                var ssppDOMFooter = $('.ajaxcart__footer')
                var ssppDOMBody = $('.ajaxcart__inner')
                var ssppDOMParentHeight = ssppDOMFooter.height()

                ssppDOMFooter.css("height", ssppDOMParentHeight + 140)
                ssppDOMBody.css("bottom", ssppDOMParentHeight + 140)

            },
            buildPopupWindow: function () {

                var popupTemplate = $('<div>', {
                    id: "packageProtectionInfoPopup",
                    class: "package-protection-info-popup"
                }).css("display", "none").append(
                    $("<div>", { class: "package-protection-content" }).append(
                        //$("<div>", { class: "title" }).text("PACKAGE PROTECTION"),
                        $('<p>').text("By opting out of package protection, you are taking on responsibility for this shipment once it is in transit. When the package is in transit without protection, the carrier and the customer become responsible."),
                        $('<p>').text("To cover any lost, stolen, or damaged packages, we offer package protection. By opting into package protection, you make it so that we can either place a new order on your behalf or refund you if any of those situations arise, giving you peace of mind."),
                        $('<a>', {
                            class: "package-protection-cancel-btn"
                        }).text("KEEP"),
                        $('<a>', {
                            class: "package-protection-continue-btn"
                        }).text("REMOVE")
                        ,
                        $('<a>', {
                            class: "package-protection-close-btn"
                        }).html('<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><polygon points="512,28.308 483.692,0 256,227.692 28.308,0 0,28.308 227.692,256 0,483.692 28.308,512 256,284.308 483.692,512 512,483.692 284.308,256"></polygon></g></g></svg>')
                    )
                )

                return popupTemplate
            },
            getCartTotal: function (cart, removePP) {
                if (removePP && removePP == true) {
                    var cartItemsWithoutIns = cart.items.filter(function (obj) {
                        return obj.vendor !== 'PackageProtection.com';
                    });
                    var subTotal = cartItemsWithoutIns.reduce(function (a, b) {
                        return b.final_line_price == null ? a : a + b.final_line_price;
                    }, 0);
                    return subTotal;
                } else {
                    return cart.items_subtotal_price
                }
            },
            confirmTogglePackageProtection: function () {
                $('.package-protection-switch').addClass('package-protection-switch-disabled')
                $('#packageProtectionInfoPopup').show()
            },
            togglePackageProtection: function (cart) {
                var _cartToken = localStorage.setItem('_ssppToken', cart.token)
                var package = JSON.parse(localStorage.getItem('sspp'))
                var enabled = (localStorage.getItem('_ssppOption') !== null) ? localStorage.getItem('_ssppOption') : true
                if (enabled === 'true') {
                    var current_variant = cart.items.find(i => i.product_id === package.id)
                    sspp.removePackageFromCart(current_variant.variant_id)
                    $('.package-protection-switch').removeClass('package-protection-switch-disabled').removeClass('package-protection-switch-active').html('OFF <span class="package-protection-switch-inner"></span>')
                    $('#packageProtectionInfoPopup').hide()
                    localStorage.setItem('_ssppOption', false);
                } else {
                  	$('.package-protection-switch').removeClass('package-protection-switch-disabled').addClass('package-protection-switch-active').html('ON <span class="package-protection-switch-inner"></span>')
                    localStorage.setItem('_ssppOption', true);
                    sspp.getCart(ssppCart.updatePackageCart)
                }
            },
        }

        let originalOpen = XMLHttpRequest.prototype.open

        XMLHttpRequest.prototype.open = function () {
            this.addEventListener('loadend', sspp.ajaxLoadEndListener)
            originalOpen.apply(this, arguments)
        }
        
        ns.fetch = function () {
            const response = fetch.apply(this, arguments)
		
            response.then(res => {
                if ([
                    `${window.location.origin}/cart/add.js`,
                    `${window.location.origin}/cart/update.js`,
                    `${window.location.origin}/cart/change.js`,
                    `${window.location.origin}/cart/clear.js`,
                    `${window.location.origin}/cart/change`,
                    `${window.location.origin}/cart/add`,
                    `${window.location.origin}/cart/update`,
                    `${window.location.origin}/cart/clear`,
                ].includes(res.url)) {
                    res.clone().json().then(data => {
                        sspp.getCart(ssppCart.updatePackageCart);
                    })
                }
            })

            return response;
        }

        sspp.init()
                  
        /*Custom Script*/
                  
        const loadOffcanvasCart = async () => {
                  
           //$('.pp-price').html("")

           //setTimeout(()=>{
              //$('.pp-price').html(window.ssppprice)
           //}, 1000)
                  
           initCartQty()
           initHandleRemoveButtons()
     
        }
                  
       const initCartQty = () => {
          document.querySelectorAll('.cart-qty').forEach((el) => {
              if (!el.classList.contains('init')) {
                  el.classList.add('init')
                  el.addEventListener('change', () => {
                      fetch('/cart/change.js', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({
                              id: el.dataset.lineItemKey,
                              quantity: el.value
                          })
                      })
                          .then((response) => response.json())
                          .then((data) => {
                              //console.log(data)
							  
                  			  sspp.getCart(ssppCart.updatePackageCart)
                  
                              document.querySelectorAll('.cart-items-count').forEach((el2) => {
                                  el2.textContent = data.item_count
                              })

                              fetch(window.location.href)
                                  .then((response) => response.text())
                                  .then((data2) => {
                                      const parser = new DOMParser()
                                      const newDocument = parser.parseFromString(data2, 'text/html')
                                      document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                                      document.querySelector('#cart-page')?.replaceWith(newDocument.querySelector('#cart-page'))
                                      if (data.items.length === 0) {
                                          setTimeout(() => {
                                              const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'))
                                              offcanvas.hide()
                                          }, 500)
                                      }
                                      initCartQty()
                                      initHandleRemoveButtons()
                                  })
                          })
                  })
              }
          })
      }

                  
      const initHandleRemoveButtons = () => {
            document.querySelectorAll('.offcanvas-cart-remove-btn').forEach((btn) => {
                if (!btn.classList.contains('init')) {
                    btn.classList.add('init')
                    btn.addEventListener('click', (e) => {
                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: btn.dataset.lineItemKey,
                                quantity: 0
                            })
                        })
                            .then((response) => response.json())
                            .then((data) => {
								sspp.getCart(ssppCart.updatePackageCart)
                  
                                document.querySelectorAll('.cart-items-count').forEach((el2) => {
                                    el2.textContent = data.item_count
                                })

                                fetch(window.location.href)
                                    .then((response) => response.text())
                                    .then((data2) => {
                                        const parser = new DOMParser()
                                        const newDocument = parser.parseFromString(data2, 'text/html')
                                        document.querySelector('#offcanvas-cart-inner')?.replaceWith(newDocument.querySelector('#offcanvas-cart-inner'))
                                        document.querySelector('#cart-page')?.replaceWith(newDocument.querySelector('#cart-page'))
                                        if (data.items.length === 0) {
                                            setTimeout(() => {
                                                const offcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-cart'))
                                                offcanvas.hide()
                                            }, 500)
                                        }
                                        initCartQty()
                                        initHandleRemoveButtons()
                                    })
                            })
                    })
                }
            })
        }

                  
    }

    if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function () {
            jQuerySSP = jQuery.noConflict(true);
            ssppApp(jQuerySSP);
        });
    } else {
        ssppApp(jQuery);
    }
                  
})(window, window.fetch);